require('@/config/bugsnag')
require('@/config/axios')
require('@/config/plugins')
require('@/config/directives')
require('@/config/global-components')
require('@/config/amplitude')
require('@/config/mixpanel')
